export enum ExplainerPanelIcon {
  DEFAULT = 'default',
  CIVIC = 'civic',
}

export enum ExplainerPanelSubDescriptionIcon {
  DEFAULT = 'default',
  FACE_AUTH = 'faceAuth',
  DOCUMENT = 'document',
  SHIELD = 'shield',
  BOT = 'bot',
  PERSON = 'person',
}

export enum ExplainerPanelDescriptionAlignment {
  DEFAULT = 'default',
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}

export interface ExplainerPanelSubDescription {
  title: string;
  icon?: ExplainerPanelSubDescriptionIcon;
  alignment?: ExplainerPanelDescriptionAlignment;
  showAppIcons?: boolean;
  showQRCode?: boolean;
}

export interface ExplainerPanelDescription {
  description: string;
  alignment?: ExplainerPanelDescriptionAlignment;
  hyperlinkText?: string;
}

export default interface ExplainerPanelProps {
  topIcon?: ExplainerPanelIcon;
  title?: string;
  description?: ExplainerPanelDescription;
  subDescriptionsWithIcon?: ExplainerPanelSubDescription[];
  subDescription: string;
  infoBoxDescription?: string;
  infoBoxLinkDescription: string;
  infoBoxLinkHref: string;
  hideInfoBoxIcon?: boolean;
  primaryButtonLabel: string;
  translationVariables: Record<string, string>;
  onPrimaryButtonPressed: () => void;
  secondaryButtonLabel: string;
  onSecondaryButtonPressed: () => void;
  footerButtonLabel?: string;
  onFooterButtonPress?: () => void;
  showDescription: boolean;
  showSubDescription: boolean;
  showSecondaryButton: boolean;
  showHeaderPanel: boolean;
  showBackButton: boolean;
  onBackButtonPressed?: () => void;
  termsLink?: string;
  privacyPolicyLink?: string;
  biometricPolicyLink?: string;
  // ID added to the panel to check in tests if the component was rendered
  dataTestId?: string;
}
